
import { Component } from '@angular/core';
import { CarouselComponent } from '../../../../modules/carousel/carousel.component';
import { CarouselTile } from '../../../../modules/carousel/carousel.model';



@Component({
  selector: 'app-boote-carousel',
  imports: [
    CarouselComponent
  ],
  templateUrl: './boote-carousel.component.html',
  styleUrls: ['./boote-carousel.component.scss']
})
export class BooteCarouselComponent {

  public tiles: CarouselTile[] = [
    {
      img: {
        src: 'assets/img/xl/pboot-b1.jpg',
        // width: 1120,
        // height: 742,
        alt: 'Unterwegs',
        // srcset: [
        //   'assets/img/xs/pboot-b1.webp 688w',
        //   'assets/img/sm/pboot-b1.webp 912w',
        //   'assets/img/md/pboot-b1.webp 1120w',
        //   'assets/img/lg/pboot-b1.webp 1360w',
        //   'assets/img/xl/pboot-b1.webp 2320w',
        // ],
        sizes: ['90vw'],
        priority: true,
        // loading: 'eager',
      }
    },
    {
      img: {
        src: 'assets/img/xl/absegeln16.jpg',
        // width: 1120,
        // height: 1493,
        alt: 'Absegeln',
        // srcset: [
        //   'assets/img/xs/absegeln16.webp 688w',
        //   'assets/img/sm/absegeln16.webp 912w',
        //   'assets/img/md/absegeln16.webp 1120w',
        //   'assets/img/lg/absegeln16.webp 1360w',
        //   'assets/img/xl/absegeln16.webp 2320w',
        // ],
        sizes: ['90vw'],
        loading: 'lazy',
      }
    },
    {
      img: {
        src: 'assets/img/cats1.jpg',
        // width: 1120,
        // height: 630,
        alt: 'Katamarane',
        // style: 'width:100%;height:100%;object-fit:cover;object-position:50% 75%;',
        objectPosition: '50% 75%',
        // srcset: [
        //   'assets/img/xs/cats1.webp 688w',
        //   'assets/img/sm/cats1.webp 912w',
        //   'assets/img/md/cats1.webp 1120w',
        //   'assets/img/lg/cats1.webp 1360w',
        //   'assets/img/xl/cats1.webp 2320w',
        // ],
        sizes: ['90vw'],
        loading: 'lazy',
      }
    },
    // {
    //   img: {
    //     src: 'assets/img/md/acat1.webp',
    //     width: 1120,
    //     height: 746,
    //     alt: 'A-Cat',
    //     srcset: [
    //       'assets/img/xs/acat1.webp 688w',
    //       'assets/img/sm/acat1.webp 912w',
    //       'assets/img/md/acat1.webp 1120w',
    //       'assets/img/lg/acat1.webp 1360w',
    //       'assets/img/xl/acat1.webp 2320w',
    //     ],
    //     sizes: ['90vw'],
    //     loading: 'lazy',
    //   }
    // },
    {
      img: {
        src: 'assets/img/h-jolle1.jpg',
        // width: 5400,  
        // height: 3542, 
        alt: 'H-Jolle des YSTM',
        // breakpoints: [300, 1020, 1410, 1710, 1970, 2190, 2400, 2590, 2760, 2930, 3090, 3240, 3380, 3520, 3648],
        sizes: ['90vw'],
        loading: 'lazy',
        // priority: true,
      }
    },

    {
      img: {
        src: 'assets/img/xl/pboot-h1.jpg',
        // width: 1120,
        // height: 723,
        alt: 'P-Boot',
        // style: 'width:100%;height:100%;object-fit:cover;object-position:50% 70%;',
        objectPosition: '50% 70%',
        // srcset: [
        //   'assets/img/xs/pboot-h1.webp 688w',
        //   'assets/img/sm/pboot-h1.webp 912w',
        //   'assets/img/md/pboot-h1.webp 1120w',
        //   'assets/img/lg/pboot-h1.webp 1360w',
        //   'assets/img/xl/pboot-h1.webp 2320w',
        // ],
        sizes: ['90vw'],
        loading: 'lazy',
      }
    },
    // {
    //   img: {
    //     src: 'assets/img/md/dn1.webp',
    //     width: 1120,
    //     height: 840,
    //     alt: 'DN-Schlitten',
    //     style: 'width:100%;height:100%;object-fit:cover;object-position:50% 70%;',
    //     srcset: [
    //       'assets/img/xs/dn1.webp 688w',
    //       'assets/img/sm/dn1.webp 912w',
    //       'assets/img/md/dn1.webp 1120w',
    //       'assets/img/lg/dn1.webp 1360w',
    //       'assets/img/xl/dn1.webp 2320w',
    //     ],
    //     sizes: ['90vw'],
    //     loading: 'lazy',
    //   }
    // },
    // {
    //   img: {
    //     src: 'assets/img/dn8.jpg',
    //     width: 5400,
    //     height: 4176, 
    //     alt: 'Eissegeln mit DN-Schlitten.',
    //     style: 'width:100%;height:100%;object-fit:cover;object-position:50% 70%;',
    //     objectPosition: '50% 70%',
    //     breakpoints: [300, 1020, 1410, 1710, 1970, 2190, 2400, 2590, 2760, 2930, 3090, 3240, 3380, 3520, 3648],
    //     sizes: ['90vw'],
    //     loading: 'lazy',
    //     priority: true,
    //   }
    // },
    {
      img: {
        src: 'assets/img/ansegeln24-01.jpg',
        // width: 5400,
        // height: 4176, 
        alt: 'Ansegeln 2024',
        // style: 'width:100%;height:100%;object-fit:cover;object-position:50% 70%;',
        objectPosition: '50% 50%',
        // breakpoints: [300, 1020, 1410, 1710, 1970, 2190, 2400, 2590, 2760, 2930, 3090, 3240, 3380, 3520, 3648],
        sizes: ['90vw'],
        loading: 'lazy',
        // priority: true,
      }
    },
    // {
    //   img: {
    //     src: 'assets/img/md/surf1.webp',
    //     width: 1120,
    //     height: 742,
    //     alt: 'Wind-Surfer im YSTM',
    //     srcset: [
    //       'assets/img/xs/surf1.webp 688w',
    //       'assets/img/sm/surf1.webp 912w',
    //       'assets/img/md/surf1.webp 1120w',
    //       'assets/img/lg/surf1.webp 1360w',
    //       'assets/img/xl/surf1.webp 1400w',
    //     ],
    //     sizes: ['90vw'],
    //     loading: 'lazy',
    //   }
    // },
    {
      img: {
        src: 'assets/img/surf1.jpg',
        // width: 4928, 
        // height: 3264, 
        alt: 'Wind-Surfer im YSTM',
        //breakpoints: [300, 1020, 1410, 1710, 1970, 2190, 2400, 2590, 2760, 2930, 3090, 3240, 3380, 3520, 3648],
        sizes: ['90vw'],
        loading: 'lazy',
      }
    },
    {
      img: {
        src: 'assets/img/steg4.jpg',
        // width: 5400, 
        // height: 3586, 
        alt: 'Regatta-Abend im YSTM',
        // breakpoints: [300, 1020, 1410, 1710, 1970, 2190, 2400, 2590, 2760, 2930, 3090, 3240, 3380, 3520, 3648],
        sizes: ['90vw'],
        loading: 'lazy',
      }
    },
  ];
}
